import React from 'react';

const GameHeader = ({ gameStatus, pageName, listScore}) => {

  const display_indicator = [];
  
  return (
    <div className="game-header-container">
      <div className="explanation-page-top-left-indicator">
        <div className="explanation-page-indicator-left">

          <div className="explanation-page-indicator-bloc explanation-page-indicator-title">
            {pageName}
          </div>

          {/* <div className="explanation-page-indicator-bloc">
            <div className="explanation-page-indicator-icon">
              <img
                src="/icon/calendar.png"
                className="explanation-page-indicator-icon-image"
                alt="Calendar"
              />
            </div>
            <div className="explanation-page-indicator-value date-indicator-value">
              12 mai 2027
            </div>
          </div> */}

          {/* <div className="explanation-page-indicator-bloc">
            <div className="explanation-page-indicator-icon">
              <img
                src="/icon/water.png"
                className="explanation-page-indicator-icon-image"
                alt="Water"
              />
            </div>
            <div className="explanation-page-indicator-value">
              {gameStatus.score_dic.water.value}
            </div>
          </div> */}

          {Array.isArray(listScore) && listScore.map((scoreDic, index) => (
            <div key={index} className="explanation-page-indicator-bloc">
              <div className="explanation-page-indicator-icon">
                <img
                  src={scoreDic.icon_url}
                  className="explanation-page-indicator-icon-image"
                  alt="Icon"
                />
              </div>
              <div className="explanation-page-indicator-value" style={{ width: '20px' }}>
                {scoreDic.min !== undefined && scoreDic.value < scoreDic.min ? scoreDic.min : scoreDic.value}
              </div>
            </div>
          ))}

        </div>
      </div>

      <div className="explanation-page-top-right">
        <div className="explanation-page-indicator-right">
          <img
            // src={gameStatus.logo}
            src="/icon/compte-goutte-white-logo.png"
            alt="Logo"
            className="explanation-page-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default GameHeader;
